import { User, UserRole } from '../types/user'
import { formatUserName } from '../utils/name'
import './UserList.css'

interface UserListProps {
  users: User[]
  onEdit: (user: User) => void
  onDelete: (id: string, name: string) => void
  onActivate: (id: string) => void
  onDeactivate: (id: string) => void
  onResetPassword: (id: string) => void
}

export function UserList({
  users,
  onEdit,
  onDelete,
  onActivate,
  onDeactivate,
  onResetPassword,
}: UserListProps) {
  const getRoleBadgeClass = (role: UserRole) => {
    switch (role) {
      case 'admin':
        return 'badge-admin'
      case 'doctor':
        return 'badge-doctor'
      case 'nurse':
        return 'badge-nurse'
      case 'receptionist':
        return 'badge-receptionist'
      default:
        return ''
    }
  }

  if (users.length === 0) {
    return (
      <div className="empty-state">
        <p>No users found</p>
      </div>
    )
  }

  return (
    <div className="user-list">
      <table className="user-table" role="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Username</th>
            <th>Email</th>
            <th>Role</th>
            <th>Status</th>
            <th>Last Login</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              <td>
                <strong>
                  {formatUserName(user)}
                </strong>
              </td>
              <td>{user.username}</td>
              <td>{user.email}</td>
              <td>
                <span className={`badge ${getRoleBadgeClass(user.role)}`}>{user.role}</span>
              </td>
              <td>
                {user.isActive ? (
                  <span className="badge badge-active">Active</span>
                ) : (
                  <span className="badge badge-inactive">Inactive</span>
                )}
              </td>
              <td>
                {user.lastLoginAt ? new Date(user.lastLoginAt).toLocaleString() : 'Never'}
              </td>
              <td>
                <div className="action-buttons">
                  <button
                    className="btn-link"
                    onClick={() => onEdit(user)}
                    aria-label={`Edit ${formatUserName(user)}`}
                  >
                    Edit
                  </button>
                  {user.isActive ? (
                    <button
                      className="btn-link"
                      onClick={() => onDeactivate(user.id)}
                      aria-label={`Deactivate ${formatUserName(user)}`}
                    >
                      Deactivate
                    </button>
                  ) : (
                    <button
                      className="btn-link"
                      onClick={() => onActivate(user.id)}
                      aria-label={`Activate ${formatUserName(user)}`}
                    >
                      Activate
                    </button>
                  )}
                  <button
                    className="btn-link"
                    onClick={() => onResetPassword(user.id)}
                    aria-label={`Reset password for ${formatUserName(user)}`}
                  >
                    Reset Password
                  </button>
                  <button
                    className="btn-link btn-danger"
                    onClick={() => onDelete(user.id, formatUserName(user))}
                    aria-label={`Delete ${formatUserName(user)}`}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}














